import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=28a2d1a1&scoped=true"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=28a2d1a1&prod&lang=stylus&scoped=true"
import style1 from "./MainTable.vue?vue&type=style&index=1&id=28a2d1a1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2d1a1",
  null
  
)

export default component.exports